/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandartProductConversionFieldDto } from '../../models/backend-standart-product-conversion-field-dto';
import { BackendStandartProductConversionFieldRequestDto } from '../../models/backend-standart-product-conversion-field-request-dto';

export interface SalesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Params {
  body: BackendStandartProductConversionFieldRequestDto;
}

export function salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandartProductConversionFieldDto>;
    }),
  );
}

salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded.PATH = '/api/sales/standard-product-conversion-fields/';
